import { useState } from "react";
import { Row, Col } from "react-bootstrap";

import ShowTag from "@/components/Mobile/ShowTag/ShowTag";

import { dateToLocale, formatMilesDecimalNew } from "@/services/Utils";

const InventoryMobileDetail = ({ inventory, handleClick, index }) => {
	const [showTag, setShowTag] = useState(false);
	const [inventorySelected, setInventorySelected] = useState("");

	const selectInventory = (i) => {
		setInventorySelected(inventory.details[i]);
		setShowTag(true);
	};

	return (
		<Col xs={12} className="main-detail">
			<div className={`main-detail-product ${inventory.active && "active"}`} onClick={() => handleClick(index)}>
				<Row>
					<Col xs={5} className="product-text">
						{inventory.NOMBRE_COMERCIAL}
					</Col>
					<Col xs={3} className="product-text important">
						{inventory.STOCK ? formatMilesDecimalNew(inventory.STOCK) : 0}
					</Col>
					<Col xs={3} className="product-text">
						{inventory.UNIDAD_DE_MEDIDA}
					</Col>
				</Row>
			</div>
			{inventory.active ? (
				<>
					{inventory.details &&
						inventory.details.map((detail, i) => {
							return (
								<Col key={i} xs={12} className="detail-inventory" onClick={() => selectInventory(i)}>
									<Row>
										<Col xs={6}>
											<div className="inventory-title">ID</div>
											<div className="inventory-detail">{detail.IDENTIFICADOR}</div>
										</Col>
										<Col xs={6}>
											<div className="inventory-title">Stock</div>
											<div className="inventory-detail">{detail.STOCK ? formatMilesDecimalNew(detail.STOCK) : 0}</div>
										</Col>
										<Col xs={6}>
											<div className="inventory-title">Venci.</div>
											<div className="inventory-detail">
												{detail.FECHA_DE_VENCIMIENTO ? dateToLocale(detail.FECHA_DE_VENCIMIENTO) : ""}
											</div>
										</Col>
										<Col xs={6}>
											<div className="inventory-title">U.M.</div>
											<div className="inventory-detail">{detail.UNIDAD_DE_MEDIDA}</div>
										</Col>
									</Row>
								</Col>
							);
						})}
				</>
			) : (
				""
			)}

			<ShowTag show={showTag} setShow={setShowTag} inventory={inventorySelected} />
		</Col>
	);
};

export default InventoryMobileDetail;
